import axios from "axios";
import { responseSuccessInterceptor, responseErrorInterceptor } from "../utils/errorHandler";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_USER_URL,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    if (typeof window !== "undefined") {
      const account = JSON.parse(localStorage.getItem("account"));
      if (account?.user?.token) config.headers.Authorization = `Bearer ${account?.user?.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptors for centralized error handling
axiosInstance.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

export default axiosInstance;
